// 법적 고지 페이지 공통 셸(이용약관/개인정보처리방침/취소·환불정책/사업자정보).
// 뒤로가기 + 제목 + 본문 컨테이너를 일관되게 제공한다. 본문은 children 으로 받는다.

import { type ReactNode } from "react";
import { useNavigate } from "react-router-dom";

// 법적 고지 페이지 공통 셸(뒤로/제목/본문 컨테이너).
export default function LegalPageShell({
  title,
  updatedAt,
  children,
}: {
  title: string;
  // 최종 개정일 표시(선택).
  updatedAt?: string;
  children: ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <main className="mx-auto flex w-full max-w-screen-sm flex-col gap-4 px-5 py-6">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="rounded-md border border-ink-300 px-2 py-1 text-sm text-ink-700 hover:bg-ink-50"
          aria-label="뒤로 가기"
        >
          뒤로
        </button>
        <h1 className="text-xl font-bold text-ink-900">{title}</h1>
      </div>
      {updatedAt ? <p className="text-xs text-ink-500">최종 개정일: {updatedAt}</p> : null}
      {/* 본문: 줄간격/문단 간격을 넉넉히 둬 가독성 확보. */}
      <div className="flex flex-col gap-4 text-sm leading-relaxed text-ink-800">{children}</div>
    </main>
  );
}

// 약관 조항 한 절(소제목 + 내용)을 표준 스타일로 묶는다.
export function LegalSection({ heading, children }: { heading: string; children: ReactNode }) {
  return (
    <section className="flex flex-col gap-1.5">
      <h2 className="text-base font-semibold text-ink-900">{heading}</h2>
      <div className="flex flex-col gap-1.5">{children}</div>
    </section>
  );
}
